import { classNames, React } from 'libs/react';
import './StoreSaleItemCardSkeleton.scss';
/**
 * Placeholder with the shape of a product card, shown while the catalog loads
 * so the grid keeps its layout. Used by the store and the sales form.
 *
 * @component StoreSaleItemCardSkeleton
 * @since 1.0.0
 */
export function StoreSaleItemCardSkeleton(props) {
    const className = classNames('store-card-skeleton', {
        'store-card-skeleton--form': props.variant === 'form'
    });
    return (React.createElement("div", { className: className, "aria-hidden": "true" },
        React.createElement("div", { className: "store-card-skeleton__image" }),
        React.createElement("div", { className: "store-card-skeleton__body" },
            React.createElement("span", { className: "store-card-skeleton__line store-card-skeleton__line--title" }),
            React.createElement("span", { className: "store-card-skeleton__line" }),
            React.createElement("span", { className: "store-card-skeleton__line store-card-skeleton__line--short" })),
        React.createElement("div", { className: "store-card-skeleton__footer" },
            React.createElement("span", { className: "store-card-skeleton__line store-card-skeleton__line--price" }),
            React.createElement("span", { className: "store-card-skeleton__button" }))));
}
